import LeaveBalance from '../model/leaveBalance'
import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export function fetchLeaveBalances(companyID?: string, employeeID?: string): Promise<RequestResponse<LeaveBalance[]>> {
  return secureRequest('GET', url('/v2/leaveBalances', { companyID, employeeID }))
}
